import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePageTitle } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";
import { ProductCard } from "@/components/site/ProductCard";

export default function Shop() {
  usePageTitle(
    "Shop — Sitebound Construction Job Seeker Packs",
    "Browse Sitebound's range of Australian construction, mining and FIFO job seeker packs. Digital downloads, AUD pricing."
  );
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products")
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, []);

  const live = products.filter((p) => p.status === "live");
  const soon = products.filter((p) => p.status === "coming_soon");

  return (
    <div data-testid="shop-page" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
      <Reveal>
        <div className="mono-label">Store</div>
        <h1 className="font-display mt-4 text-5xl font-extrabold uppercase tracking-tight text-slate-100 sm:text-6xl">
          The Range
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-400">
          Digital job seeker packs for Australian construction, civil, mining and FIFO work. One
          live now — the rest are in production. Hit notify me and you'll be first to know.
        </p>
      </Reveal>

      {loading ? (
        <div data-testid="shop-loading" className="mt-16 text-sm uppercase tracking-widest text-slate-500">
          Loading the range…
        </div>
      ) : (
        <>
          <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {live.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.06}>
                <ProductCard product={p} index={i} />
              </Reveal>
            ))}
          </div>
          <h2 className="font-display mt-20 text-3xl font-bold uppercase tracking-tight text-slate-300">
            In production
          </h2>
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {soon.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.05}>
                <ProductCard product={p} index={i + live.length} />
              </Reveal>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
